'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _desc, _value, _class;

var _servicesCore = require('@makerdao/services-core');

var _bignumber = require('bignumber.js');

var _bignumber2 = _interopRequireDefault(_bignumber);

var _constants = require('../utils/constants');

var _tracksTransactions = require('../utils/tracksTransactions');

var _tracksTransactions2 = _interopRequireDefault(_tracksTransactions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var maxAllowance = (0, _bignumber2.default)(_constants.UINT256_MAX).shiftedBy(-18);

var AllowanceService = (_class = function (_PrivateService) {
  (0, _inherits3.default)(AllowanceService, _PrivateService);

  function AllowanceService() {
    var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'allowance';
    (0, _classCallCheck3.default)(this, AllowanceService);

    var _this = (0, _possibleConstructorReturn3.default)(this, (AllowanceService.__proto__ || (0, _getPrototypeOf2.default)(AllowanceService)).call(this, name, ['token', 'event']));

    _this._shouldMinimizeAllowance = false;
    return _this;
  }

  (0, _createClass3.default)(AllowanceService, [{
    key: 'initialize',
    value: function initialize(settings) {
      if (settings && settings.useMinimizeAllowancePolicy) {
        this._shouldMinimizeAllowance = true;
      }
    }
  }, {
    key: 'requireAllowance',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(tokenSymbol, receiverAddress, _ref2) {
        var _ref2$estimate = _ref2.estimate,
            estimate = _ref2$estimate === undefined ? maxAllowance : _ref2$estimate,
            promise = _ref2.promise;

        var token, ownerAddress, allowance, tx, _tx;

        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                token = this.get('token').getToken(tokenSymbol);
                ownerAddress = this.get('token').get('web3').currentAddress();
                _context.next = 4;
                return token.allowance(ownerAddress, receiverAddress);

              case 4:
                allowance = _context.sent;

                if (!(allowance.lt(maxAllowance.div(2)) && !this._shouldMinimizeAllowance)) {
                  _context.next = 11;
                  break;
                }

                _context.next = 8;
                return token.approveUnlimited(receiverAddress, { promise: promise });

              case 8:
                tx = _context.sent;

                this.get('event').emit('allowance/APPROVE', {
                  transaction: tx
                });
                return _context.abrupt('return', tx);

              case 11:
                if (!(allowance.lt(estimate) && this._shouldMinimizeAllowance)) {
                  _context.next = 16;
                  break;
                }

                _context.next = 14;
                return token.approve(receiverAddress, estimate, { promise: promise });

              case 14:
                _tx = _context.sent;

                this.get('event').emit('allowance/APPROVE', {
                  transaction: _tx
                });

              case 16:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function requireAllowance(_x2, _x3, _x4) {
        return _ref.apply(this, arguments);
      }

      return requireAllowance;
    }()
  }, {
    key: 'removeAllowance',
    value: function () {
      var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(tokenSymbol, spenderAddress, _ref4) {
        var promise = _ref4.promise;
        var token, allowance;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                token = this.get('token').getToken(tokenSymbol);
                _context2.next = 3;
                return token.allowance(this.get('token').get('web3').currentAddress(), spenderAddress);

              case 3:
                allowance = _context2.sent;

                if (!(parseInt(allowance) != 0)) {
                  _context2.next = 6;
                  break;
                }

                return _context2.abrupt('return', token.approve(spenderAddress, '0', { promise: promise }));

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function removeAllowance(_x5, _x6, _x7) {
        return _ref3.apply(this, arguments);
      }

      return removeAllowance;
    }()
  }]);
  return AllowanceService;
}(_servicesCore.PrivateService), (_applyDecoratedDescriptor(_class.prototype, 'requireAllowance', [_tracksTransactions2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'requireAllowance'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'removeAllowance', [_tracksTransactions2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'removeAllowance'), _class.prototype)), _class);
exports.default = AllowanceService;